import { render, staticRenderFns } from "./A9.vue?vue&type=template&id=f953eb90&"
import script from "./A9.vue?vue&type=script&lang=ts&"
export * from "./A9.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports